import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  icon: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    columnGap: theme.spacing(1),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    rowGap: theme.spacing(1),
  },
}));

export default useStyles;
